import { Constantes } from '@/services/helper/constantes';

/*
 * Central de Vagas. Cada item do menu (seg_menu, serviço 26) aponta para uma rota daqui pelo
 * `name` — ver docs/pre-matricula/sql/menu/001_MenuCentralVagas.sql na API acadêmica:
 *
 *   Inscrições     Campanha → prematricula_processos · Controle/Manutenção → controle_inscricoes
 *   Configurações  Zoneamento → prematricula_zonas · Vagas → prematricula_vagas
 *   (os relatórios estão em ../relatorios/routes.ts)
 *
 * `controle_inscricoes` muda conforme o contrato: PREMATRICULA_POR_PROCESSO abre a pré-matrícula
 * por processo (tabelas Prm); senão, a variante de Cachoeirinha (INSCRICAO_ONLINE). A Central de
 * Vagas legada (ListaEspera) foi removida. A pré-matrícula é conferida ANTES de propósito:
 * `CONTRATO_CACHOEIRINHA` é verdadeiro em QUALQUER localhost.
 *
 * Toda rota que um item de menu cita TEM de existir: sem ela, o menu abre a URL antiga do legado.
 */
export default [
  {
    description: 'Controle/Manutenção',
    path: '/centralvagas/inscricoes/controle',
    name: 'controle_inscricoes',
    component: () => {
      if (Constantes.PREMATRICULA_POR_PROCESSO) {
        return import('@/views/centralvagas/prematricula/InscricoesIndex.vue');
      }

      return import('@/views/centralvagas/inscricoes/controle_cachoeirinha.vue');
    },
    meta: {
      isLegacy: false,
      permissions: [
      ],
    },
    goesToMenu: true,
  },
  {
    description: 'Inscrição na lista de espera',
    path: '/centralvagas/inscricoes/prematricula/inscricao/:id?',
    parent: 'controle_inscricoes',
    name: 'prematricula_inscricao',
    component: () => import('@/views/centralvagas/prematricula/InscricaoCadastro.vue'),
    meta: {
      isLegacy: false,
      permissions: [],
    },
  },
  {
    description: 'Campanha',
    path: '/centralvagas/inscricoes/prematricula/processos',
    name: 'prematricula_processos',
    component: () => import('@/views/centralvagas/prematricula/ProcessosIndex.vue'),
    meta: {
      isLegacy: false,
      permissions: [],
    },
    goesToMenu: true,
  },
  {
    description: 'Estudantes matriculados',
    path: '/centralvagas/inscricoes/prematricula/relatorio-matriculados',
    name: 'prematricula_relatorio_matriculados',
    component: () => import('@/views/centralvagas/prematricula/RelatorioMatriculados.vue'),
    meta: {
      isLegacy: false,
      permissions: [],
    },
  },
  {
    description: 'Lista classificada',
    path: '/centralvagas/inscricoes/prematricula/classificacao',
    parent: 'controle_inscricoes',
    // Sem item de menu próprio (por ora): abre pelo botão da tela de inscrições.
    name: 'prematricula_classificacao',
    component: () => import('@/views/centralvagas/prematricula/ClassificacaoPreMatricula.vue'),
    meta: {
      isLegacy: false,
      permissions: [],
    },
  },
  {
    description: 'Vagas externas e credenciamento',
    path: '/centralvagas/inscricoes/prematricula/vagas-externas',
    parent: 'controle_inscricoes',
    // Sem item de menu próprio (por ora): abre pelo botão da tela de inscrições.
    name: 'prematricula_vagas_externas',
    component: () => import('@/views/centralvagas/prematricula/VagasExternas.vue'),
    meta: {
      isLegacy: false,
      permissions: [],
    },
  },
  {
    description: 'Relatórios do questionário',
    path: '/centralvagas/inscricoes/prematricula/relatorio-questionario',
    parent: 'controle_inscricoes',
    // Sem item de menu próprio (por ora): abre pelo botão da tela de inscrições.
    name: 'prematricula_relatorio_questionario',
    component: () => import('@/views/centralvagas/prematricula/RelatorioQuestionario.vue'),
    meta: {
      isLegacy: false,
      permissions: [],
    },
  },
  {
    description: 'Cadastros duplicados',
    path: '/centralvagas/inscricoes/prematricula/cadastros-duplicados',
    parent: 'controle_inscricoes',
    // Sem item de menu próprio (por ora): abre pelo botão da tela de inscrições.
    name: 'prematricula_duplicados',
    component: () => import('@/views/centralvagas/prematricula/CadastrosDuplicados.vue'),
    meta: {
      isLegacy: false,
      permissions: [],
    },
  },
  {
    description: 'Recadastramento',
    path: '/centralvagas/inscricoes/prematricula/recadastramento',
    parent: 'prematricula_processos',
    // Sem item de menu próprio (por ora): abre pelo botão da tela de processos (campanhas).
    name: 'prematricula_recadastramento',
    component: () => import('@/views/centralvagas/prematricula/Recadastramento.vue'),
    meta: {
      isLegacy: false,
      permissions: [],
    },
  },
  {
    description: 'Zoneamento',
    path: '/centralvagas/inscricoes/prematricula/zonas',
    name: 'prematricula_zonas',
    component: () => import('@/views/centralvagas/prematricula/ZonasIndex.vue'),
    meta: {
      isLegacy: false,
      permissions: [],
    },
    goesToMenu: true,
  },
  {
    // Configurações > Vagas: a PREVISÃO DE VAGAS por escola × ano × nível (limite da rematrícula
    // e saldo para a lista de espera).
    description: 'Vagas',
    path: '/centralvagas/configuracoes/vagas',
    name: 'prematricula_vagas',
    component: () => import('@/views/centralvagas/prematricula/PrevisaoVagas.vue'),
    meta: {
      isLegacy: false,
      permissions: [],
      titulo: 'Vagas',
    },
    goesToMenu: true,
  },
  {
    description: 'Dúvidas do portal',
    path: '/centralvagas/inscricoes/prematricula/duvidas',
    parent: 'controle_inscricoes',
    // Sem item de menu próprio (por ora): abre pelo botão da tela de inscrições.
    name: 'prematricula_duvidas',
    component: () => import('@/views/centralvagas/prematricula/DuvidasPortal.vue'),
    meta: {
      isLegacy: false,
      permissions: [],
    },
  },
  {
    description: 'Manual da Central de Vagas',
    path: '/centralvagas/inscricoes/prematricula/ajuda',
    parent: 'controle_inscricoes',
    // Sem item de menu próprio (por ora): abre pelo botão da tela de inscrições.
    name: 'prematricula_ajuda',
    component: () => import('@/views/centralvagas/prematricula/AjudaCentralVagas.vue'),
    meta: {
      isLegacy: false,
      permissions: [],
    },
  },
  {
    description: 'Zona',
    path: '/centralvagas/inscricoes/prematricula/zonas/cadastro/:id?',
    parent: 'prematricula_zonas',
    name: 'prematricula_zona',
    component: () => import('@/views/centralvagas/prematricula/ZonaCadastro.vue'),
    meta: {
      isLegacy: false,
      permissions: [],
    },
  },
  {
    description: 'Processo de inscrição',
    path: '/centralvagas/inscricoes/prematricula/processos/cadastro/:id?',
    parent: 'prematricula_processos',
    name: 'prematricula_processo',
    component: () => import('@/views/centralvagas/prematricula/ProcessoCadastro.vue'),
    meta: {
      isLegacy: false,
      permissions: [],
    },
  },
]
